
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { MuniSpinner2 } from "../../../components";
import { useEffect, useState } from "react";

import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useActas } from "../../../hooks/useActas";


const ModalRecibo = ({ titleModal, titleMensaje, mensaje, variant, confirm }) => {
    const { modals, handlerModal, loads } = useGeneralAppStore();
    const { acta, recibo, setRecibo } = useActaDetalleStore()
    const { obtenerRecibo } = useActas();

    useEffect(() => {
        obtenerRecibo({ pago_voluntario_id: acta.pago_voluntario_id })

        return () => {
            setRecibo(null)
        }
    }, [])

    return (
        <>
            <Modal
                show={modals.includes('modal_recibo')}
                onHide={() => handlerModal({ modal: false, modalName: "modal_recibo" })}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{
                    backgroundColor: modals.length > 1 && modals[0] === 'acta_detalle' ? 'rgba(0,0,0,0.4)' : '',
                }}
            >
                <div className="position-relative">
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titleModal}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex flex-column gap-3" style={{ height: "600px" }}>
                            {
                                loads.includes('obtener_recibo') ?
                                    (
                                        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                                            <MuniSpinner2 />
                                        </div>
                                    ) :
                                    <div className="w-100 h-100 ">
                                        {
                                            recibo ?
                                                <>
                                                    <a
                                                        href={recibo?.pdf?.base64}
                                                        download={`${acta.dependencia}-${acta.numero_acta}`}
                                                        className="text-center mb-3 px-1 d-block"
                                                        style={{ border: "2px #1334c9 dashed" }}
                                                    >
                                                        DESCARGAR RECIBO PARA IMPRESIÓN
                                                    </a>
                                                    <iframe width={"100%"} height={"90%"} src={recibo?.pdf?.base64} />
                                                </>
                                                :
                                                <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                                                    <Alert variant="danger" className="p-5 rounded"><h3 className="m-0 text-danger">No se genero recibo</h3></Alert>
                                                </div>
                                        }
                                    </div>
                            }
                        </div>
                    </Modal.Body>
                </div>
            </Modal>


        </>
    );
}
export default ModalRecibo;